import { useCallback, useEffect, useState } from 'react';
const STORAGE_KEY = 'hiring_employees_data';
export function useEmployeesData() {
    const [employeesData, setEmployeesData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => {
        try {
            const stored = localStorage.getItem(STORAGE_KEY);
            if (stored) {
                const parsed = JSON.parse(stored);
                setEmployeesData(parsed);
            }
        }
        catch (err) {
            setError('Erro ao carregar dados dos colaboradores');
        }
        finally {
            setIsLoading(false);
        }
    }, []);
    const saveEmployeesData = useCallback((data) => {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
            setEmployeesData(data);
            setError(null);
        }
        catch (err) {
            setError('Erro ao salvar dados dos colaboradores');
        }
    }, []);
    const clearEmployeesData = useCallback(() => {
        try {
            localStorage.removeItem(STORAGE_KEY);
            setEmployeesData(null);
            setError(null);
        }
        catch (err) {
            setError('Erro ao limpar dados dos colaboradores');
        }
    }, []);
    return {
        employeesData,
        isLoading,
        error,
        saveEmployeesData,
        clearEmployeesData,
    };
}
